export const urlList =  {
  // dev: 'http://47.105.135.188:9527',
  // dev: 'http://192.168.188.152:9527',
  dev: 'https://saasapi.fangxinqian.cn',
  pro: 'https://saasapi.fangxinqian.cn',
  // pro: 'https://saasapitest.fangxinqian.cn',
}

/**
 *js调用APP
 * @params {*} Obj  传给app参数
 */
 export function JSToNativeAPP(params) {
  let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
  let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    window.webkit.messageHandlers.backwap.postMessage(params)
  } else {
    window.backwap.toBack()
  }
}

export const baseurl = process.env.NODE_ENV === 'production'? urlList.pro : urlList.dev

export const uploadurl = process.env.NODE_ENV === 'production'? '/template/uploadImg' : '/apis/template/uploadImg'


export const cookieExpires = '30d'


// WEBPACK FOOTER //
// ./src/libs/config/index.js